import {
	useQueryClient,
	useMutation,
	type UseMutationOptions,
} from '@tanstack/react-query';
import {
	addAttributeVocabularyValue,
	type QueryError,
	type AddAttributeVocabularyValueResult,
	type AddAttributeVocabularyValueRequestOptions,
} from '../addAttributeVocabularyValue';
import {splitEventHandler} from '@netx/core-next/utils';
export * from '../addAttributeVocabularyValue';

import {GetAttributeVocabularyValuesReactQueryKey} from './useReactQueryGetAttributeVocabularyValues';

export type AddAttributeVocabularyValueQueryOptions = Omit<
	UseMutationOptions<
		AddAttributeVocabularyValueResult,
		QueryError,
		AddAttributeVocabularyValueRequestOptions,
		AddAttributeVocabularyValueResult
	>,
	'mutationFn'
> & {
	mutationFn?: typeof addAttributeVocabularyValue;
};

/**
 * react-query wrapper for `addAttributeVocabularyValue`
 * @param queryKeyParams
 * @param options
 */
export const useReactQueryAddAttributeVocabularyValue = ({
	mutationFn = addAttributeVocabularyValue,
	...options
}: AddAttributeVocabularyValueQueryOptions = {}) => {
	const queryClient = useQueryClient();
	return useMutation<
		AddAttributeVocabularyValueResult,
		QueryError,
		AddAttributeVocabularyValueRequestOptions,
		AddAttributeVocabularyValueResult
	>({
		mutationFn,
		...options,
		onSuccess: splitEventHandler(
			options.onSuccess,
			(data, variables, context) => {
				queryClient.invalidateQueries([
					GetAttributeVocabularyValuesReactQueryKey,
					{id: variables.id},
				]);
			},
		),
	});
};

export default useReactQueryAddAttributeVocabularyValue;
